//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    data: function data() {
        return {
            deposit: {},
            depositTotalAmount: 0,
            depositTotalItems: 0,
            modifyPayment: false,
            deletePayment: false,
            isReconcileTransaction: false,
            paymentTypes: null,
            modDeposit: { id: 0 },
            loading: true,
            remove: false,
            residents: null,
            reversalReasons: [],
            reversalReasonId: 0
        };
    },
    created: function created() {
        var _this = this;

        var $el = this;

        Event.$on('view-deposit', function (item) {
            Object.assign(_this.$data, _this.$options.data());
            $el.load(item);
        });
        Event.$on('delete-deposit', function (item) {
            Event.$emit('refresh-ar-deposits');
            Event.$emit('close-small-modal');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('view-deposit');
        Event.$off('delete-deposit');
    },

    methods: {
        load: function load(deposit) {
            var _this2 = this;

            var $el = this;

            axios.get('/prototype/accounting/accounts-receivable/billings/reversal-reasons').then(function (response) {
                $el.reversalReasons = [];
                response.data.forEach(function (r, index) {
                    if (r.fixed_code !== 'PAYMR') {
                        $el.reversalReasons.push({
                            name: r.reason,
                            value: r.id
                        });
                    }
                });
            });

            axios.post('/prototype/accounting/accounts-receivable/deposits/show', { id: deposit.id }).then(function (response) {
                $el.deposit = response.data;
                if ($el.deposit.reconcile_transaction) {
                    $el.isReconcileTransaction = true;
                }
            }).then(function (response) {
                _this2.calculateDepositTotals();
            });

            $el.loading = false;
            $el.$children[0].$data.showSmallModal = true;
        },
        getUnit: function getUnit(p) {
            if (p.applicant_ledger_id) {
                return 'Applicant';
            }

            if (p.ledger) {
                if (p.ledger.resident && p.ledger.resident.unit) {
                    return p.ledger.resident.unit.name;
                }

                if (p.ledger.applicant && p.ledger.applicant.person) {
                    return 'Applicant';
                }
            }
            return '';
        },
        getName: function getName(p) {
            if (p.applicant_ledger_id) {
                if (p.applicant_ledger && p.applicant_ledger.applicant && p.applicant_ledger.applicant.person) {
                    return p.applicant_ledger.applicant.person.full_name;
                }
            }

            if (p.ledger) {
                if (p.ledger && p.ledger.resident && p.ledger.resident.person) {
                    return p.ledger.resident.person.full_name;
                }

                if (p.ledger && p.ledger.applicant && p.ledger.applicant.person) {
                    return p.ledger.applicant.person.full_name;
                }
            }
            return '';
        },
        addPayment: function addPayment() {
            var _this3 = this;

            var $el = this;
            this.modifyPayment = true;
            this.deletePayment = false;
            this.modDeposit = { id: 0 };
            axios.get('/api/paymentTypes').then(function (response) {
                return _this3.paymentTypes = response.data;
            });
            axios.get(BASE_URL + '/residents-and-applicants').then(function (response) {
                $el.residents = response.data;
                $el.residents.map(function (item) {
                    item.full_name = (item.is_applicant ? 'Applicant' : item.unit ? item.unit.name : '') + ': ' + item.person.full_name;
                    delete item.person;
                    delete item.property;
                    delete item.unit;
                });
                $el.modDeposit.payment_type = $el.paymentTypes[0];
            });
        },
        editPayment: function editPayment(payment) {
            this.deletePayment = true;
            this.modifyPayment = true;
            this.modDeposit = payment;

            if (payment.reversal !== null) {
                this.modDeposit.reversal_reason_id = payment.reversal.reversal_reason_id;
                this.modDeposit.notes = payment.reversal.notes;
            } else {
                // @TODO: clean this up
                this.modDeposit.reversal_reason_id = 0;
                this.modDeposit.notes = null;
            }

            this.modDeposit.resident = payment.applicant_ledger ? payment.applicant_ledger.applicant : payment.ledger.applicant ? payment.ledger.applicant : payment.ledger.resident;
            this.modDeposit.resident['full_name'] = payment.applicant_ledger ? 'Applicant: ' + payment.applicant_ledger.applicant.person.full_name : payment.ledger.applicant ? 'Applicant: ' + payment.ledger.applicant.person.full_name : payment.ledger.resident.unit.name + ' : ' + payment.ledger.resident.person.full_name;
        },
        savePayment: function savePayment() {
            var _this4 = this;

            if (this.modDeposit.resident) {

                if (this.modDeposit.amount >= 0) {
                    this.loading = true;
                    var data = {
                        deposit: this.deposit,
                        modifyPayment: this.modifyPayment,
                        deletePayment: this.deletePayment,
                        paymentTypes: this.paymentTypes,
                        modDeposit: this.modDeposit,
                        loading: this.loading,
                        remove: this.remove,
                        residents: this.residents
                    };
                    axios.post('/prototype/accounting/accounts-receivable/deposits/singlePayment', data).then(function (response) {
                        _this4.modifyPayment = false;
                        _this4.remove = false;
                        _this4.loading = false;
                        _this4.load(response.data);
                        _this4.modDeposit = {};
                        Event.$emit('refresh-ar-deposits');
                    });
                } else {
                    this.$snotify.error('Amount cannot be negative...');
                }
            }
        },
        removePayment: function removePayment(payment) {
            var _this5 = this;

            this.loading = true;

            payment.reversalReasonId = this.reversalReasonId;
            payment.notes = this.modDeposit.notes;

            axios.post('/prototype/resident/ledger/payments/destroy', payment).then(function (response) {
                if (response.data.error) {
                    _this5.$snotify.error(response.data.error);
                } else {
                    _this5.$snotify.success('Payment Reversed');
                    _this5.modifyPayment = false;
                    _this5.deletePayment = false;
                    _this5.remove = false;
                    _this5.loading = false;
                    _this5.modDeposit = {};
                    _this5.load(_this5.deposit);
                    Event.$emit('refresh-ar-deposits');
                }
            });
        },
        updateReasonForReversal: function updateReasonForReversal(selectedVal) {
            this.reversalReasonId = selectedVal ? selectedVal.value : null;
        },
        calculateDepositTotals: function calculateDepositTotals() {
            this.depositTotalAmount = 0;
            this.depositTotalItems = 0;
            if (this.deposit.payments) {
                var depositItems = this.deposit.payments.filter(function (payment) {
                    return payment.reversal === null;
                });

                this.depositTotalItems = depositItems.length;
                this.depositTotalAmount = depositItems.reduce(function (acc, payment) {
                    return parseFloat(acc) + parseFloat(payment.amount);
                }, 0);
            }
        },
        removeDeposit: function removeDeposit() {
            Event.$emit('confirm-delete', this.deposit, '/prototype/accounting/accounts-receivable/deposits/destroy', 'delete-deposit');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-receivable/deposits/ARDepositDetails.vue
// module id = BU7h
// module chunks = 0 1